import { render } from "./SideNavComponentBuyer.vue?vue&type=template&id=09bc0b75&scoped=true"
import script from "./SideNavComponentBuyer.vue?vue&type=script&lang=js"
export * from "./SideNavComponentBuyer.vue?vue&type=script&lang=js"

import "./SideNavComponentBuyer.vue?vue&type=style&index=0&id=09bc0b75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bc0b75"]])

export default __exports__